// @flow
import React from "react"

import Translate from "../../../../app/scripts/components/Translate"

type Props = {|
  onClose: () => void,
  title: string,
  store: string,
  link: string,
  onClick: () => void,
|}

const MobileAdComponent = (props: Props) => (
  <div className="MobileAd">
    <i className="md-close MobileAd-close" onClick={props.onClose} />
    <span className="MobileAd-content">
      <img className="MobileAd-content-image" src="/images/about/app-logo.png" alt="" />
      <span className="MobileAd-content-text">
        <span className="MobileAd-content-text-title">{props.title}</span>
        <span>Kiwi.com s.r.o.</span>
        {props.store}
      </span>
    </span>

    <div className="MobileAd-button-wrapper">
      <a className="MobileAd-button spBtn" href={props.link} onClick={props.onClick}>
        <Translate tKey="common.download" />
      </a>
    </div>
  </div>
)

export default MobileAdComponent
